// extracted by mini-css-extract-plugin
export var accountManagerErrorButton = "account-manager__error-button_MkCnUgz4GeKaTxY4qk5A";
export var accountManagerItem = "account-manager__item_NbSygODS0n2TaZwdA4IV";
export var accountManagerName = "account-manager__name_NNKUaR4cvAuwLsXcdSbh";
export var accountManagerPopoverEmail = "account-manager__popover-email_CYLWJHbSKMFJU78fXK3C";
export var accountManagerPopoverLink = "account-manager__popover-link_mdvAMaxaCQwW2y_sRuhR";